export const dataLayer1 = {
  id: 'MapData',
  type: 'fill',
  paint: {
    'fill-color': {
      property: 'percentile',
      stops: [
        [0, '#ffe5e5'],
        [1, '#ffcccc'],
        [2, '#ffb2b2'],
        [3, '#ff9999'],
        [4, '#ff7f7f'],
        [5, '#ff6666'],
        [6, '#ff4c4c'],
        [7, '#ff3232'],
        [8, '#ff1919'],
        [9, '#cc0000'],
        [10, '#990000'],
        [11, '#800000'],
        [12, '#4d0000']


      ]
    },
    'fill-opacity': 0.8,
    'fill-outline-color': '#000000'
  }
};

export const dataLayer2 = {
  id: 'MapData',
  type: 'fill',
  paint: {
    'fill-color': {
      property: 'percentile',
      stops: [
        [0, '#e1fffe'],
        [1, '#cdfffd'],
        [2, '#b9fffc'],
        [3, '#a5fffb'],
        [4, '#91fffa'],
        [5, '#73fff8'],
        [6, '#55fff7'],
        [7, '#37fff5'],
        [8, '#00f0e5'],
        [9, '#00b4ab'],
        [10, '#007872'],
        [11, '#00504c'],
        [12, '#013331']

      ]
    },
    'fill-opacity': 0.8,
    'fill-outline-color': '#000000'
  }
};

export const dataLayer3 = {
  id: 'MapData',
  type: 'fill',
  paint: {
    'fill-color': {
      property: 'percentile',
      stops: [
        [0, '#f5e6ff'],
        [1, '#e6ccff'],
        [2, '#d9b3ff'],
        [3, '#cc99ff'],
        [4, '#bf80ff'],
        [5, '#b266ff'],
        [6, '#9933ff'],
        [7, '#8000ff'],
        [8, '#7300e6'],
        [9, '#6600cc'],
        [10, '#5900b3'],
        [11, '#4d0099'],
        [12, '#330066']

      ]
    },
    'fill-opacity': 0.8,
    'fill-outline-color': '#000000'
  }
};

export const dataLayer4 = {
  id: 'MapData',
  type: 'fill',
  paint: {
    'fill-color': {
      property: 'percentile',
      stops: [
        [0, '#e6ffe6'],
        [1, '#ccffcc'],
        [2, '#b3ffb3'],
        [3, '#99ff99'],
        [4, '#80ff80'],
        [5, '#66ff66'],
        [6, '#4dff4d'],
        [7, '#33cc33'],
        [8, '#2eb82e'],
        [9, '#269926'],
        [10, '#1f7a1f'],
        [11, '#196619'],
        [12, '#0d330d']

      ]
    },
    'fill-opacity': 0.8,
    'fill-outline-color': '#000000'
  }
};